import { render } from "./RoverChangeTariffPage.vue?vue&type=template&id=59351504&scoped=true"
import script from "./RoverChangeTariffPage.vue?vue&type=script&lang=js"
export * from "./RoverChangeTariffPage.vue?vue&type=script&lang=js"

import "./RoverChangeTariffPage.vue?vue&type=style&index=0&id=59351504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59351504"]])

export default __exports__